"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.manageShipments = void 0;
var Ceramic = __importStar(require("@amzn/ceramic-jsx"));
var ceramic_jsx_1 = require("@amzn/ceramic-jsx");
var ceramic_components_1 = require("@amzn/ceramic-components");
var Utils_1 = require("../assets/scripts/Utils");
var Constants_1 = require("../constants/Constants");
var NavigationRow_1 = require("../components/NavigationRow");
var state = new Utils_1.ManageShipmentsPageState();
exports.manageShipments = (Ceramic.createCeramicElement(ceramic_jsx_1.Page, { id: "ManageShipmentsPageId", version: "1.0.0", imports: [
        Utils_1.Utils.__import
    ], dataSources: [
        {
            name: 'state',
            inlineData: state
        }
        // , { // The following section serves as an example of how to localize your mobile pages. A detailed explanation can be found in the README.
        //
        //     /** The name with which you will refer to your translations file */
        //     name: 'translations',
        //
        //     /** The URI to your translations file. This needs to be in the structure defined below. Make sure to import Grout from @amzn/ceramic-jsx.
        //      Grout.application.preferredLocale will provide the client's locale in the format 'en-us'. For local testing, use the URI
        //      'http://localhost:4321/AffordabilityWebsite/i18n/translation-' + Grout.application.preferredLocale.split('-')[0] + '.json'*/
        //     uri: (): string => {
        //         return 'https://rainier-m1k.integ.amazon.com/AffordabilityWebsite/i18n/translation-' + Grout.application.preferredLocale.split('-')[0] + '.json'
        //     },
        //
        //     /** This onSuccess handler will essentially do what the useBundle() function does and return the desired bundle from the translation file.
        //      To debug, you can use Grout.console.debug to print the extracted bundle and see it via the Debug console. */
        //     onSuccess: (response: any) => {
        //         Grout.console.debug('bundle: ' + response[Grout.application.preferredLocale]['<BundleName>']);
        //         return response[Grout.application.preferredLocale]['<BundleName>'];
        //     },
        // }
    ], assets: {
        templates: {
            "NavigationRow": (Ceramic.createCeramicElement(NavigationRow_1.NavigationRow, null))
        }
    } },
    Ceramic.createCeramicElement(ceramic_jsx_1.ActionBar, { title: "Manage Shipments", showAppIcon: true }),
    Ceramic.createCeramicElement(ceramic_jsx_1.LinearContainer, { id: "ManageShipmentsPageMainContainer", height: 'fill', width: 'fill' },
        Ceramic.createCeramicElement(ceramic_jsx_1.LinearContainer, { id: "ManageShipmentsPageTilesContainer", orientation: "horizontal", height: "wrap", scrollable: true, padding: '8dp 8dp 8dp 8dp', border: "1dp solid ".concat(Constants_1.ManageShipmentPageColors.borderColor), backgroundColor: Constants_1.ManageShipmentPageColors.tileContainerColor },
            Ceramic.createCeramicElement(ceramic_components_1.Tile, { label: "Active Shipments", value: "26" }),
            Ceramic.createCeramicElement(ceramic_components_1.Tile, { label: "In Fulfillment Center", value: "3851" }),
            Ceramic.createCeramicElement(ceramic_components_1.Tile, { label: "Inbound", value: "40" })),
        Ceramic.createCeramicElement(ceramic_components_1.SearchBar, { placeholder: "Search for a shipment" }),
        Ceramic.createCeramicElement(ceramic_jsx_1.List, { id: "ManageShipmentsPageList", height: "fill", dataSources: [
                {
                    name: 'data',
                    type: 'dynamic',
                    uri: Constants_1.Constants.Apis.ListApi,
                    onSuccess: Utils_1.Utils.modifyListData
                }
            ], registeredRowTemplates: ['NavigationRow'], defaultRowTemplate: 'NavigationRow' }))));
exports.default = (0, ceramic_jsx_1.render)(exports.manageShipments);
